const updates = [
  { date: '2026-07-28', title: '《咒术回战》最终章已完整上线，全卷免费下拉阅读', tag: '热门' },
  { date: '2026-07-27', title: '平台新增 150 部韩漫热门作品，甜宠恋爱题材大量更新', tag: '上新' },
  { date: '2026-07-26', title: '下拉式阅读体验全新升级，加载速度提升30%', tag: '优化' },
  { date: '2026-07-25', title: '《鬼灭之刃》全系列引进完毕，包含外传与番外篇', tag: '热门' },
  { date: '2026-07-24', title: '国漫专区新增《一人之下》《狐妖小红娘》全章节', tag: '上新' },
  { date: '2026-07-23', title: '夜间阅读模式灰度上线，护眼追更两不误', tag: '优化' },
  { date: '2026-07-22', title: '《间谍过家家》第二季完整汉化已同步更新', tag: '热门' },
  { date: '2026-07-21', title: '异世界题材专题整理上线，一键浏览全部相关作品', tag: '专题' },
  { date: '2026-07-20', title: '搜索功能全面升级，支持按作者、题材、连载状态筛选', tag: '优化' },
];

export default function UpdatesSection() {
  const tagColors: Record<string, string> = {
    '热门': 'bg-primary-100 text-primary-700',
    '上新': 'bg-accent-100 text-accent-700',
    '优化': 'bg-secondary-100 text-secondary-700',
    '专题': 'bg-accent-100 text-accent-700',
  };

  return (
    <section id="updates" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            每日更新站点资讯与漫画上新动态，追更快人一步
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((u, i) => (
            <div
              key={i}
              className={`flex items-start gap-4 py-4 ${
                i < updates.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className="flex-shrink-0 w-24 text-xs text-foreground-400 pt-0.5 whitespace-nowrap">
                {u.date}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-800 leading-relaxed">{u.title}</p>
              </div>
              <span
                className={`flex-shrink-0 inline-block px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                  tagColors[u.tag] || 'bg-background-200 text-foreground-600'
                }`}
              >
                {u.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}